import React from 'react'
import { Box, Link, styled } from '@mui/material'
import { useSelector } from 'react-redux'
import MaterialSymbol from '../../../../components/MaterialSymbol'
import Typography from '../../../../components/Typography'
import { colors } from '../../../../themes/colors'
import StoreAvailabilityModal from './StoreAvailabilityModal'
import TestIds from '../../../../testIds'
import { useBranch } from '../../../../util/useBranch'
import { selectPickupStores } from '../../../stores/storage/stores.slice'

const FlexRow = styled(Box)({
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
})

export const StoreModalOpenLink = ({ name, productId }: { name: string; productId: number }) => {
  const [openModal, setOpenModal] = React.useState(false)
  const stores = useSelector(selectPickupStores)
  const branchId = useBranch()
  const selectedStore = stores.find((x) => x.inventorySiteId === branchId)

  return (
    <FlexRow data-testid={TestIds.feat.stock.storeAvailabilitiesLink}>
      <MaterialSymbol sx={{ color: colors.primary500 }}>location_on</MaterialSymbol>
      <Typography
        variant='body2'
        color={'primary500'}
        component={Link}
        onClick={() => setOpenModal(true)}
      >
        {name}
      </Typography>

      <StoreAvailabilityModal
        open={openModal}
        setOpen={setOpenModal}
        productId={productId}
        selectedStore={selectedStore}
        testId={TestIds.feat.stock.storeAvailabilitiesModal}
      />
    </FlexRow>
  )
}
